"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultProps = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Divider = function Divider(_ref) {
  var orientation = _ref.orientation,
      weight = _ref.weight,
      rest = _objectWithoutProperties(_ref, ["orientation", "weight"]);

  return /*#__PURE__*/_react.default.createElement(_Divider.default, _extends({
    light: weight !== "strong",
    orientation: orientation
  }, rest));
};

Divider.propTypes = {
  /**
   * Which orientation to use.
   */
  orientation: _propTypes.default.oneOf(_constants.availableOrientations),

  /**
   * Which weight option to use — "strong" will have a darker color.
   */
  weight: _propTypes.default.oneOf(_constants.availableWeights)
};
var defaultProps = {
  orientation: "horizontal",
  weight: "default"
};
exports.defaultProps = defaultProps;
Divider.defaultProps = _objectSpread({}, defaultProps);
Divider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Divider",
  "props": {
    "orientation": {
      "defaultValue": {
        "value": "\"horizontal\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableOrientations"
      },
      "required": false,
      "description": "Which orientation to use."
    },
    "weight": {
      "defaultValue": {
        "value": "\"default\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableWeights"
      },
      "required": false,
      "description": "Which weight option to use \u2014 \"strong\" will have a darker color."
    }
  }
};
var _default = Divider;
exports.default = _default;